import React, { useState, useEffect } from 'react';
import './LocationDisplay.css';

const cities = [
  'Houston',
  'The Woodlands'
];

const LocationDisplay: React.FC = () => {
  const [selectedCity, setSelectedCity] = useState<string>('Houston');

  useEffect(() => {
    // Load saved location from localStorage
    const savedCity = localStorage.getItem('selectedCity');
    if (savedCity) {
      setSelectedCity(savedCity);
    }
  }, []);

  const handleCityChange = (city: string) => {
    setSelectedCity(city);
    localStorage.setItem('selectedCity', city);
    // Reload the page to apply the filter
    window.location.reload();
  };

  return (
    <div className="location-display">
      <div className="location-info">
        <span className="location-icon">📍</span>
        <span className="location-text">
          <strong>{selectedCity}</strong>
        </span>
      </div>
      <select
        value={selectedCity}
        onChange={(e) => handleCityChange(e.target.value)}
        className="location-dropdown"
      >
        {cities.map((city) => (
          <option key={city} value={city}>{city}</option>
        ))}
      </select>
    </div>
  );
};

export default LocationDisplay;
